import { Button } from "@mantine/core"
import { ArrowLeftIcon, MapPinIcon } from "@phosphor-icons/react"
import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from "react-router-dom"
import { DeliveryRouteDetail } from "../../components/delivery-routes/DeliveryRouteDetail"
import { PageLayout } from "../../components/layout"
import { usePermission } from "../../components/permission"

export function DeliveryRouteDetailPage() {
  const { t } = useTranslation(["delivery", "common"])
  // delivery-route/get.ts: DEL_ROUTE_PLAN (or the assigned driver / loader, who use the mobile app).
  const DEL_ROUTE_PLAN = usePermission("DEL_ROUTE_PLAN")
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const breadcrumbs = useBreadcrumb(t)

  return (
    <PageLayout
      icon={<MapPinIcon size={22} />}
      title={t("delivery:route.detail.title")}
      subTitle={t("delivery:route.detail.subtitle")}
      breadcrumb={breadcrumbs}
      extra={[
        <Button
          key="back"
          variant="default"
          leftSection={<ArrowLeftIcon size={18} />}
          onClick={() => navigate(-1)}
        >
          {t("delivery:route.detail.back")}
        </Button>,
      ]}
    >
      {!id ? null : DEL_ROUTE_PLAN.hasAccess ? (
        <DeliveryRouteDetail routeId={id} />
      ) : (
        DEL_ROUTE_PLAN.accessDenied()
      )}
    </PageLayout>
  )
}

const useBreadcrumb = (t: (key: string) => string) => [
  { to: "/", label: t("common:breadcrumb.home") },
  { to: "/supplier-delivery?tab=ROUTES", label: t("delivery:route.detail.crumbManage") },
  { to: "/delivery-routes", label: t("delivery:route.title") },
  { label: t("delivery:route.detail.crumb") },
]
